import * as tslib_1 from "tslib";
import { PrivateMediaService } from '../private-media';
import { getScaleToFillImageURL } from '@wix/image-client-api/dist/imageClientSDK';
var MediaApi = /** @class */ (function () {
    function MediaApi(api) {
        this.api = api;
        this.mediaService = new PrivateMediaService();
    }
    MediaApi.prototype.uploadFile = function (file) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.getMediaToken()];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, this.mediaService.uploadFile(file, data.token)];
                }
            });
        });
    };
    MediaApi.wixStaticFileUrl = function (fileUrl) {
        return MediaApi.WIX_STATIC + "/" + fileUrl;
    };
    MediaApi.wixStaticVideoUrl = function (fileUrl) {
        return MediaApi.WIX_STATIC_VIDEO_BASE_URL + "/" + mediaIdFromUrl(fileUrl);
    };
    MediaApi.wixStaticImageUrl = function (fileUrl) {
        return MediaApi.WIX_STATIC + "/media/" + mediaIdFromUrl(fileUrl);
    };
    MediaApi.getWixmpFileNameFromImageURL = function (wixMPImageURL) {
        var path = wixMPImageURL.replace(MediaApi.WIXMP_IMAGE_BASE_URL, '');
        var fileName = path.split('/').pop().split('?')[0];
        return { path: path, fileName: fileName };
    };
    MediaApi.isWixmpImageURL = function (image) {
        if (!image) {
            return false;
        }
        return image.startsWith(MediaApi.WIXMP_IMAGE_BASE_URL);
    };
    MediaApi.prototype.getImageUrl = function (fileUploadResponse, targetWidth, targetHeight) {
        var file_url = fileUploadResponse.file_url, height = fileUploadResponse.height, width = fileUploadResponse.width;
        //https://github.com/wix-private/santa-core/tree/master/image-client-api#getscaletofillimageurl
        return getScaleToFillImageURL(file_url, width, height, targetWidth || width, targetHeight || height);
    };
    MediaApi.WIXMP_IMAGE_BASE_URL = 'https://images-wixmp-7ef3383b5fd80a9f5a5cc686.wixmp.com';
    MediaApi.WIX_STATIC = 'https://static.wixstatic.com';
    MediaApi.WIX_STATIC_VIDEO_BASE_URL = 'https://video.wixstatic.com/video';
    return MediaApi;
}());
export { MediaApi };
/**
 *  replaces substring that starts with
 *  - /
 *  - /media
 *  - /video
 *  - /media/video
 * @param {string} mediaUrl
 * @return {string}
 */
function mediaIdFromUrl(mediaUrl) {
    return mediaUrl.replace(/(^\/*(media*\/*)?(video*\/*)?)/g, '');
}
//# sourceMappingURL=MediaApi.js.map